import axios from 'axios';

// Единый axios-инстанс на всё приложение.
// withCredentials — чтобы сессионная cookie Django всегда уходила с запросом.
// Интерцептор добавляет X-CSRFToken на все небезопасные методы — без этого
// DRF (SessionAuthentication) отвечает 403 "CSRF Failed" даже анонимным сессиям.
const axiosClient = axios.create({
  withCredentials: true,
});

const UNSAFE_METHODS = ['post', 'put', 'patch', 'delete'];

function getCookie(name) {
  try {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
  } catch (error) {
    return null;
  }
}

axiosClient.interceptors.request.use((config) => {
  const method = (config.method || 'get').toLowerCase();
  if (UNSAFE_METHODS.includes(method)) {
    const csrfToken = getCookie('csrftoken');
    if (csrfToken) {
      config.headers = config.headers || {};
      config.headers['X-CSRFToken'] = csrfToken;
    }
  }
  return config;
});

export default axiosClient;
